/**
 * Client brand — mirrors server/config/brand.js defaults.
 * Set VITE_BRAND_* at build time; APP_URL is also window origin after cutover.
 */
const DEFAULT_LOGO = '/soviq-logo-full.png'

function resolveBrandLogo(raw: string | undefined): string {
  const logo = String(raw || '').trim()
  if (!logo || /varshyl-logo|constructinvoice-logo|constructinv[-_]?logo/i.test(logo)) {
    return DEFAULT_LOGO
  }
  return logo
}

export const brand = {
  name: import.meta.env.VITE_BRAND_NAME || 'SOVIQ AI',
  short: import.meta.env.VITE_BRAND_SHORT || 'SOVIQ',
  domain: import.meta.env.VITE_BRAND_DOMAIN || 'soviqai.com',
  appUrl: String(import.meta.env.VITE_APP_URL || '').replace(/\/$/, ''),
  supportEmail: import.meta.env.VITE_SUPPORT_EMAIL || 'support@soviqai.com',
  logo: resolveBrandLogo(import.meta.env.VITE_BRAND_LOGO),
  legalEntity: import.meta.env.VITE_LEGAL_ENTITY || 'Varshyl Inc.',
} as const
